import Cookies from 'js-cookie';

/**
 * 设置cookie
 * @param name {string}
 * @param value {string|number}
 * @param options {object}
 */
const set = (
  name,
  value,
  options = {
    path: '/',
    expires: 1,
  },
) => {
  Cookies.set(name, value, options);
};

/**
 * 获取cookie
 * @param name {string}
 * @param options {object}
 */
const get = (name, options = {}) => {
  const value = Cookies.get(name, options);
  return value;
};

/**
 * 删除cookie
 * @param name {string}
 * @param options {object}
 */
const remove = (
  name,
  options = {
    path: '/',
  },
) => {
  Cookies.remove(name, options);
};

export { get, remove, set };
